import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import {SearchKeywordSortType} from '../../graphql/generated/types';

export const SEARCH_STATE_NAME = 'search';

export const SEARCH_AUTO_COMPLETE_DEFAULT_SIZE = 10;
// 작품 검색 기본 조건
export const SEARCH_SERIES_DEFAULT_SIZE = 25;

/** 카테고리 전체를 나타냅니다. */
export const SEARCH_DEFAULT_CATEGORY_UID = '0';
export const SEARCH_KEYWORD_DEFAULT_SORT_TYPE = SearchKeywordSortType.Accuracy;
export const SEARCH_KEYWORD_DEFAULT_SHOW_ONLY_COMPLETE = false;

export const PC_SEARCH_MODAL_ROOT_ID = 'pc-search-modal-root-id';

export const SEARCH_INPUT_MAX_LENGTH = 65;

export const CATEGORY_UID_TO_TITLE_MAP: {[index: string]: string} = {
  [SEARCH_DEFAULT_CATEGORY_UID]: '전체',
  [CategoryTypeVo.Cartoon]: '웹툰',
  [CategoryTypeVo.Novel]: '웹소설',
  [CategoryTypeVo.Book]: '책',
  [CategoryTypeVo.KatalkNovel]: '채팅소설',
};
